export default __webpack_public_path__ + "static/avatar-group-7ba31ba4e3d940fa6a29ba769afe09da.png";